import { put, takeEvery, select } from "redux-saga/effects";
import { appNotify, fetchDashboardTaskCountByStatus, setCompletedTasksIsLoading, setDashboardClosedTasks, setDashboardTerminatedTasks } from "../store/actions";
import { getWithToken, postWithToken } from "../api/network";
import { dashboardFilterSelector } from 'store/selectors';

export function* getDashboardTaskCountByStatusSaga() {
  yield takeEvery(fetchDashboardTaskCountByStatus, function* ({payload}) {
    try {
      yield put(setCompletedTasksIsLoading(true));

      var filter = yield select(dashboardFilterSelector);
      const data = {
        channels: payload.channel,
        numbersOfDaysBackwards: payload.numbersOfDaysBackwards,
        loadOptions: {
          select: ["Opportunity"],
          remoteSelect: true,
          filter: filter,
          group: [{ "selector": "Opportunity", "desc": false, "isExpanded": false }]
        }
      }

      const dashboardTasks = [];
      const url = `/api/dashboard/getDashboardFinishedWorkflowData`;
      yield postWithToken(url, data)
        .then(response => response.json())
        .then((data) => {
          data.data.forEach((group) => {
            dashboardTasks[group.key] = group.count;
          })
        });

      // unfortunatly due to query join the opportunity is sent back to front in numeric value
      // we dont wont to modify the output of devextrems DataSourceLoader.LoadAsync method in API
      yield put(setDashboardTerminatedTasks(dashboardTasks[5] ?? 0));
      yield put(setDashboardClosedTasks(dashboardTasks[6] ?? 0));

      yield put(setCompletedTasksIsLoading(false));
    } catch (error)  {
      yield put(appNotify(`Failed to fetch dashboard tasks: ${error.message}`, 'error'));
      yield put(setCompletedTasksIsLoading(false));
    }
  });
}

function* fetchCount(status, channels, numbersOfDaysBackwards, filter) {
  const statusFilter = `status=${status}`;
  const daysFilter = `numbersOfDaysBackwards=${numbersOfDaysBackwards}`;

  let url = `/api/dashboard/GetDashboardOpportunitiesCount?${statusFilter}&${daysFilter}`

  if (channels.length) {
    const channelsFilter = "&channels=" + channels.join('&channels=');
    url += channelsFilter;
  }

  if (filter && filter.filterSQL) {
    url += `&filter=${encodeURI(filter.filterSQL)}`;
  }

  const res = yield getWithToken(url);
  const result = yield res.json();

  console.log(`${channels} ${status} tasks in last ${numbersOfDaysBackwards}: `, result);

  return result.count || 0;
}
